export default __webpack_public_path__ + "static/media/lgLTVN.1433946c.png";